import { APIException } from './api-exception';

export class APIServerException extends APIException {
  constructor(message: string) {
    super(message);
  }
}